import IndustryLandingTemplate, { IndustryPageData } from '@/components/industry/IndustryLandingTemplate';

const automobileData: IndustryPageData = {
  slug: 'automobile',
  name: 'Automobile Dealers & Service Centers',
  heroHeadline: 'Drive More Customers with Trusted Google Reviews',
  heroSubheadline: 'Help your car dealership or service center build credibility with AI-generated review suggestions from satisfied vehicle owners.',
  painPoint: '91% of car buyers read online reviews before visiting a dealership',
  trustProblem: 'A single negative review about pricing or service can cost you lakhs in lost sales.',
  challenges: [
    {
      title: 'High-Value Purchase Hesitation',
      description: 'Buying a car is a major decision. Customers research extensively and prioritize dealers with proven track records.',
    },
    {
      title: 'Service Center Trust Issues',
      description: 'Car owners are skeptical about service centers. Without reviews, they assume the worst about pricing and quality.',
    },
    {
      title: 'Brand-Specific Searches',
      description: 'When people search "Maruti service center in Pune" or "Honda showroom near me", you need to appear first.',
    },
    {
      title: 'Post-Purchase Silence',
      description: 'Customers are excited about their new car but rarely think to leave a review. The moment passes.',
    },
  ],
  useCases: [
    {
      category: 'Vehicle Sales',
      description: 'Reviews from happy car buyers about their purchase experience.',
      keywords: ['car showroom', 'best price', 'smooth delivery'],
    },
    {
      category: 'Service & Repairs',
      description: 'Reviews about service quality, pricing, and turnaround time.',
      keywords: ['car service', 'genuine parts', 'quick repair'],
    },
    {
      category: 'Insurance & Finance',
      description: 'Reviews about financing options and insurance assistance.',
      keywords: ['easy loan', 'best insurance', 'EMI options'],
    },
  ],
  caseStudy: {
    businessType: 'Authorized Car Service Center',
    city: 'Pune',
    challenges: [
      'Only 28 reviews despite servicing 50+ cars weekly',
      'Not appearing in "car service Pune" or brand-specific searches',
      'Customers choosing unauthorized garages due to trust issues',
    ],
    solution: 'Implemented Review Plum with categories for Regular Service, Repairs, and Genuine Parts. Created QR codes for service advisors to share with customers at delivery.',
    results: [
      { metric: 'Google Reviews', value: '28 → 156' },
      { metric: 'Google Rating', value: '3.9 → 4.5' },
      { metric: 'Service Bookings', value: '+60%' },
      { metric: 'Customer Return Rate', value: '+35%' },
    ],
  },
  sampleReviews: [
    {
      category: 'Vehicle Sales',
      reviews: [
        {
          text: 'Excellent experience buying my new Hyundai Creta from this showroom in Pune! The sales team was knowledgeable and not pushy at all. They offered the best price with great exchange value for my old car. The delivery process was smooth with proper PDI. Best car dealer in Kothrud for Hyundai.',
          keywords: ['car showroom in Pune', 'Hyundai dealer', 'Kothrud'],
        },
        {
          text: 'Bought my first car from this dealership and the experience was fantastic. They helped me understand all the variants and features patiently. The finance team arranged a great loan with low EMI. Highly recommend this automobile dealer for anyone looking to buy a car in Pune.',
          keywords: ['car dealership', 'automobile dealer', 'buy car in Pune'],
        },
      ],
    },
    {
      category: 'Service',
      reviews: [
        {
          text: 'Got my car serviced here and the quality is excellent! They used genuine parts and completed the service on time. The service advisor explained all the work done in detail. Best authorized car service center in Pune.',
          keywords: ['car service Pune', 'genuine parts', 'authorized service center'],
        },
        {
          text: 'Brought my car for AC repair and they fixed it in just one day. Very reasonable pricing compared to other workshops. The waiting lounge is comfortable with good amenities. Highly recommend for quick car repairs in Kothrud.',
          keywords: ['AC repair', 'car repairs Kothrud', 'quick service'],
        },
      ],
    },
    {
      category: 'Parts',
      reviews: [
        {
          text: 'Needed brake pads for my Maruti and they had the genuine parts in stock. No waiting time and proper billing. The parts come with warranty. Best place for genuine car spare parts in Pune.',
          keywords: ['genuine spare parts Pune', 'brake pads', 'Maruti parts'],
        },
        {
          text: 'Replaced my car battery here at a very competitive price. They helped with installation and disposed of the old battery properly. Quick service and original products. Trusted dealer for automobile parts in Maharashtra.',
          keywords: ['car battery', 'automobile parts Maharashtra', 'battery replacement'],
        },
      ],
    },
  ],
  cityKeywords: [
    'car showroom Mumbai',
    'service center Delhi',
    'automobile dealer Bengaluru',
    'car workshop Chennai',
    'vehicle service Pune',
    'auto garage Hyderabad',
  ],
  nearMeKeywords: [
    'car service near me',
    'car showroom near me',
    'automobile dealer nearby',
    'vehicle service close by',
    'car repair near me',
    'service center nearby',
  ],
  ctaText: 'Get More Customer Reviews',
};

export default function AutomobilePage() {
  return <IndustryLandingTemplate data={automobileData} />;
}
